import React, {useState, useEffect} from 'react'
import '../css/header_carga.css'
import { Outlet, Link } from "react-router-dom";
import carga_rodada from '../assets/images/menu-icons/transporte-de-carga-rodada.svg'
import feedering from '../assets/images/menu-icons/feedering.svg'
import chartering from '../assets/images/menu-icons/chartering.svg'
import carga_proyecto from '../assets/images/menu-icons/carga-proyecto.svg'
import auto_transporte from '../assets/images/menu-icons/auto-transporte.svg'
import intermodal from '../assets/images/menu-icons/intermodal.svg'
import multimodal from '../assets/images/menu-icons/multimodal.svg'
import contract_logistic from '../assets/images/menu-icons/contract-logistic.svg'
import agente_naviero from '../assets/images/menu-icons/agente-naviero.svg'
import ferroviario from '../assets/images/menu-icons/ferroviario.svg'
import freight_forwarding from '../assets/images/menu-icons/freight-forwarding.svg'
import carga from '../assets/images/soluciones/btn-carga.svg'

import turismo from '../assets/images/turismo.svg'
import informacion from '../assets/images/menu-icons/informacion.svg'

import rutasyhorarios from '../assets/images/menu-icons/rutasyhorarios.svg'
import tarifas from '../assets/images/menu-icons/tarifas.svg'
import promociones from '../assets/images/menu-icons/promociones.svg'
import viaja from '../assets/images/menu-icons/viaja.svg'
import itinerario from '../assets/images/menu-icons/itinerario.svg'

import facebook_icon from '../assets/images/grises/facebook-gris.svg'
import instagram_icon from '../assets/images/grises/instagram-alt-circle-gris.svg'
import spotify_icon from '../assets/images/grises/spotify-gris.svg'
import twitter_icon from '../assets/images/grises/twitter-alt-circle-gris.svg'
import whatsapp_icon from '../assets/images/grises/whatsapp-grises.svg'
import youtube_icon from '../assets/images/grises/youtube-alt-circle-blanco.svg'

import facebook_icon_blue from '../assets/images/azul/facebook.png'
import instagram_icon_blue from '../assets/images/azul/instagram.png'
import spotify_icon_blue from '../assets/images/azul/spotify.png'
import twitter_icon_blue from '../assets/images/azul/twitter.png'
import whatsapp_icon_blue from '../assets/images/azul/whatsapp.png'
import youtube_icon_blue from '../assets/images/azul/youtube.png'
import { useTranslation } from 'react-i18next';

export default function HeaderCarga() {
    const [isSubmenu, setIsSubmenu] = useState(false);
    const [isAviso] = useState(false);
    const [isActive, setActive] = useState(false);
    const [lateralMenu, setLateralMenu] = useState(false);
    const [scroll, setScroll] = useState(false);
    const [dropdown, setDropdown] = useState(false);

    const { i18n } = useTranslation();
    const { t } = useTranslation('header_carga');
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        setCurrentLanguage(language); // Actualizar estado
    };


    const toggleDropdown = (index) => {      
        console.log("Anterior", dropdown);
        setDropdown((prevState) => (prevState === index ? null : index));
        console.log("Nuevo", dropdown);
      };
    
    useEffect(() => {
        const handleScroll = () => {
        const isScrolled = window.scrollY > 20; // Cambia este valor según tus necesidades
        if (isScrolled !== scroll) {
            setScroll(isScrolled);
        }
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
    }, [scroll]);
    const toggleSubmenu = (index) => {

        setIsSubmenu((prevState) => (prevState === index ? null : index));
    };
    const closeSubmenu = () => {

        setIsSubmenu(false); 
       // console.log("Anterior", isActive );
        setActive(false);
       // console.log("Nuevo", isActive );
        setLateralMenu(false);
    };
    const toggleMenuExpanded = () => {
        setActive(!isActive);  
    };

    const toggleLateralMenu = () => {   
        console.log("anterior: ", lateralMenu);     
        setLateralMenu(!lateralMenu);
        console.log("Nuevo: ", lateralMenu);
    };

  return (
    <>
    {isAviso &&(
        <>
            <section className='avisoHeader'>
                <div className='container'>
                    <div className='avisoHeader_content'>
                        <p>  <i class="fi fi-ss-triangle-warning"></i>¡Atención!: Sigue la trayectoria de la tormenta tropical "Ileana" </p>
                        <label>
                        <a class="btn_aviso_cintillo" href="https://smn.conagua.gob.mx/es/animacion-imagenes-de-satelite?satelite=GOES%20Este&amp;nombre=Pac%C3%ADfico%20-%20Sur&amp;tipo=Tope%20de%20Nubes" target="_blank" rel="noopener noreferrer">Ir ahora</a>
                        </label>
                    </div>
                </div>
            </section>
            <section className='avisoHeader' style={{ background: '#007bff', color: '#fff'}}>
            <div className='container'>
                <div className='avisoHeader_content'>                 
                    <p style={{color:'#fff'}}>Consulta el ajuste de itinerario </p>
                    <label> <Link to="/aviso" className="btn_aviso_cintillo" style={{color: '#fff', border: '2px solid #fff'}}>Ver más</Link> </label>
                    
                </div>
                
            </div>
            </section>
        </>
    )}

    <header>
        <div className='header-top-carga'>
            <div className='container'>
                <div className='header-top-content'>
                    <a href="tel:8003377437" target="_blank" rel="noopener noreferrer"><i class="fi fi-ss-circle-phone"></i> 800 337 74 37 </a>  
                    <div className='header-top-box'>
                        <a href="https://facturacion.bajaferries.com" target="_blank" rel="noopener noreferrer">{t('title4')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>                      
                        <a href="http://proveedores.bajaferries.com/ProveedoresLogin.aspx" target="_blank" rel="noopener noreferrer">{t('title6')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>                      
                    </div>
                </div>
            </div>
        </div>

        <div className={`main-header-carga ${scroll ? "scrolled" : null}`}>
            <div className='container'>
                <div className='main-header-content'>
                    
                    <Link to="/soluciones-logisticas"> <div className='logo-carga'></div></Link>
                    <div className='header-item-list-carga'>
                        <ul>                        
                            <li><Link onClick={() => toggleSubmenu(1)} >{t('title1')} <i class="fi fi-br-angle-small-down"></i></Link>
                                {isSubmenu === 1 &&(
                                <div className='submenu-item carga'>
                                    <ul className={`submenu-ite ${isSubmenu ? 'submenu-item-open' : ''}`}>
                                        <div className='submenu-description carga'>                                            
                                            <Link to="/maritimo"  className='submenu-box-title'>
                                                <h3>{t('title1')}</h3>
                                                <p>{t('text1')}</p>
                                            </Link>                                          
                                        </div>
                                        <div className='submenu-description carga'>
                                            <li><Link to="/maritimo" >
                                                <div className='submenu-description-content carga'>
                                                    <img src={carga_rodada} alt='destinos'/>                                                    
                                                    <div className='submenu-description-box'>
                                                        <div>                                                        
                                                            <h2>{t('opc1')}</h2>
                                                            <p>{t('opc1_description')}</p>
                                                        </div>
                                                    </div>
                                                </div> 
                                            </Link></li>
                                            {/*<li><Link to="/maritimo">
                                                <div className='submenu-description-content carga'>
                                                    <img src={feedering} alt='destinos'/>                                                                                                            
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('opc15')}</h2>
                                                        <p>{t('opc2_description')} </p>
                                                    </div>
                                                </div>
                                            </Link> </li>*/}
                                             <li><Link to="/maritimo">
                                                <div className='submenu-description-content carga'>
                                                    <img src={feedering} alt='destinos'/>                                                                                                            
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('opc2')}</h2>
                                                        <p>{t('opc2_description')} </p>
                                                    </div>
                                                </div>                                               
                                            </Link> </li>                                            
                                            <li><Link to="/maritimo#chartering" >
                                                <div className='submenu-description-content carga'>
                                                    <img src={chartering} alt='destinos'/>                                                    
                                                    <div className='submenu-description-box'>
                                                        <div>                                                        
                                                            <h2>{t('opc3')}</h2>
                                                            <p>{t('opc3_description')}</p>
                                                        </div>                                                       
                                                    </div>                                               
                                                </div> 
                                            </Link></li>
                                            <li><Link to="/maritimo">
                                                <div className='submenu-description-content carga'>
                                                    <img src={carga_proyecto} alt='destinos'/>                                                                                                            
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('opc4')} </h2>
                                                        <p>{t('opc4_description')}</p>
                                                    </div>
                                                </div>                                               
                                            </Link> </li>
                                            <li><Link to="/maritimo">
                                                <div className='submenu-description-content carga'>
                                                    <img src={agente_naviero} alt='destinos'/>                                                                                                            
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('opc5')}  </h2>
                                                        <p>{t('opc5_description')}</p>
                                                    </div>
                                                </div>                                               
                                            </Link> 
                                            </li>
                                        </div>
                                        <div className='submenu-description carga'>                                        
                                            {/*<img src={viaja} alt='viaja'/>  */}  
                                            <div className='informacion maritimo'></div>  
                                        </div>                                        
                                    </ul>
                                </div>
                                )}
                                </li>
                           {/* <li><Link onClick={() => toggleSubmenu(2)} >{t('title2')} <i class="fi fi-br-angle-small-down"></i></Link>
                            {isSubmenu === 2 &&(
                                <div className='submenu-item carga'>
                                    <ul className={`submenu-ite ${isSubmenu ? 'submenu-item-open' : ''}`}>
                                        <div className='submenu-description carga'>                                            
                                            <div className='submenu-box-title'>                                            
                                                <Link to="/terrestre"  className='submenu-box-title'>
                                                    <h3>{t('title2')}</h3>
                                                    <p>{t('text2')}</p>
                                                </Link>   
                                            </div>                                          
                                        </div>
                                        <div className='submenu-description carga'>
                                            <li>
                                                <Link to="/terrestre" >
                                                    <div className='submenu-description-content carga'>
                                                        <img src={auto_transporte} alt='destinos'/>                                                    
                                                        <div className='submenu-description-box'>
                                                            <div>                                                        
                                                                <h2>{t('opc6')}</h2>
                                                                <p>{t('opc6_description')}</p>
                                                            </div>                                                       
                                                        </div>                                               
                                                    </div> 
                                                </Link>
                                            </li>                                            
                                        </div>
                                       
                                    </ul>
                                </div>
                                )}</li>*/}
                            {/*<li><Link onClick={() => toggleSubmenu(3)} >Ferroviario <i class="fi fi-br-angle-small-down"></i></Link>
                            {isSubmenu === 3 &&(
                                <div className='submenu-item carga'>
                                    <ul className={`submenu-ite ${isSubmenu ? 'submenu-item-open' : ''}`}>
                                        <div className='submenu-description carga'>                                            
                                            <div className='submenu-box-title'>
                                                <h3>Ferroviario</h3>
                                                <p>¡Descubre cómo nuestros servicios marítimos pueden optimizar tu cadena de suministro y llevar tu negocio al siguiente nivel!</p>
                                            </div>                                          
                                        </div>
                                        <div className='submenu-description carga'>
                                            <li><Link to="/prepara-tu-viaje" >
                                                <div className='submenu-description-content carga'>
                                                    <img src={preparaTuViaje} alt='destinos'/>                                                    
                                                    <div className='submenu-description-box'>
                                                        <div>                                                        
                                                            <h2>Transporte de carga rodada</h2>
                                                            <p>Consulta los requisitos para viajar y evita contratiempos</p>
                                                        </div>
                                                       
                                                    </div>                                               
                                                </div> 
                                            </Link></li>
                                            <li><Link to="/preguntas-frecuentes">
                                                <div className='submenu-description-content carga'>
                                                    <img src={preguntasFrecuentes} alt='destinos'/>                                                                                                            
                                                    <div className='submenu-description-box'>
                                                        <h2>Feedering</h2>
                                                        <p>Si tienes dudas o necesitas consultar algo, puedes llamar al 800 337 7437.</p>
                                                    </div>
                                                </div>                                               
                                            </Link> </li>
                                            <li><Link to="/flota" >
                                                <div className='submenu-description-content carga'>
                                                    <img src={nuestraFlota} alt='destinos'/>                                                    
                                                    <div className='submenu-description-box'>
                                                        <div>                                                        
                                                            <h2>Chartering</h2>
                                                            <p>Calidad, Innovación y Responsabilidad</p>
                                                        </div>                                                       
                                                    </div>                                               
                                                </div> 
                                            </Link></li>
                                            <li><Link to="/contacto">
                                                <div className='submenu-description-content carga'>
                                                    <img src={contacto} alt='destinos'/>                                                                                                            
                                                    <div className='submenu-description-box'>
                                                        <h2>Carga proyecto</h2>
                                                        <p>Contáctenos y le responderemos a la brevedad posible.</p>
                                                    </div>
                                                </div>                                               
                                            </Link> </li>
                                            <li><Link to="/contacto">
                                                <div className='submenu-description-content carga'>
                                                    <img src={contacto} alt='destinos'/>                                                                                                            
                                                    <div className='submenu-description-box'>
                                                        <h2>Agente Naviero </h2>
                                                        <p>Contáctenos y le responderemos a la brevedad posible.</p>
                                                    </div>
                                                </div>                                               
                                            </Link> 
                                            </li>
                                        </div>
                                        <div className='submenu-description carga'>                                        
                                            {/*<img src={viaja} alt='viaja'/>  /}  
                                            <div className='informacion'></div>  
                                        </div>                                        
                                    </ul>
                                </div>
                                )}
                            </li>*/}
                            
                            <li><Link onClick={() => toggleSubmenu(4)} >{t('title7')}<i class="fi fi-br-angle-small-down"></i></Link>
                            {isSubmenu === 4 &&(
                                <div className='submenu-item carga'>
                                    <ul className={`submenu-tite ${isSubmenu ? 'submenu-item-open' : ''}`}>
                                        <div className='submenu-description carga'>
                                            <Link to="/integracion-logistica"  className='submenu-box-title'>
                                                <h3>{t('title3')}</h3>
                                                <p>{t('text3')}</p>
                                            </Link>                                                                              
                                        </div>
                                        <div className='submenu-description carga'>
                                            
                                           {/* <li><Link to="/integracion-logistica">
                                                <div className='submenu-description-content carga'>
                                                    <img src={ferroviario} alt='destinos'/>
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('opc7')}</h2>
                                                        <p>{t('opc7_description')}</p>
                                                    </div>
                                                </div>                                               
                                            </Link> </li>*/}
                                            <li><Link to="/integracion-logistica">
                                                <div className='submenu-description-content carga'>
                                                    <img src={intermodal} alt='destinos'/>
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('opc8')}</h2>
                                                        <p>{t('opc8_description')}</p>
                                                    </div>
                                                </div>                                               
                                            </Link> </li>
                                            <li><Link to="/integracion-logistica" >
                                                <div className='submenu-description-content carga'>
                                                    <img src={multimodal} alt='destinos'/>                                                    
                                                    <div className='submenu-description-box'>
                                                        <div>                                                        
                                                            <h2>{t('opc9')}</h2>
                                                            <p>{t('opc9_description')}</p>
                                                        </div>                                                       
                                                    </div>                                               
                                                </div> 
                                            </Link></li>
                                            <li><Link to="/terrestre">
                                                <div className='submenu-description-content carga'>
                                                    <img src={auto_transporte} alt='destinos'/>
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('opc6')} <i class="fi fi-rs-arrow-up-right-from-square" style={{fontSize:'12px', marginLeft:'4px', marginTop:'0px'}}></i></h2>
                                                        <p>{t('opc6_description')}</p>
                                                    </div>
                                                </div>                                               
                                            </Link> </li>

                                            <li><Link to="/integracion-logistica">
                                                <div className='submenu-description-content carga'>
                                                    <img src={contract_logistic} alt='destinos'/>
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('opc10')} </h2>
                                                        <p>{t('opc10_description')}</p>
                                                    </div>
                                                </div>                                               
                                            </Link> </li>
                                            
                                            {/*<li><Link to="/integracion-logistica">
                                                <div className='submenu-description-content carga'>
                                                    <img src={freight_forwarding} alt='destinos'/>
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('opc11')} </h2>
                                                        <p>{t('opc11_description')}</p>
                                                    </div>
                                                </div>                                               
                                            </Link> 
                                            </li>*/}
                                        </div>
                                        <div className='submenu-description carga'>                                        
                                            {/*<img src={viaja} alt='viaja'/>  */}  
                                            <div className='informacion integracion'></div>  
                                        </div>                                        
                                    </ul>
                                </div>
                                )}
                            </li>
                 
                            <li className='itinerario_option'><Link to="/viaje-en-curso">{t('title8')}</Link></li>
                        </ul>
                    </div>                                   
                    <div className='header-item-list-carga'>
                        <ul>
                           
                            <li><Link to="/" className='btn-turismo'><img src={turismo} alt='baja ferries regresar' />  <label>{t('title5')}</label></Link></li>                                   
                            <li  onClick={() => toggleSubmenu(3)}> <label style={{display:'flex', 'color': '#fff', fontSize: '14px'}} onClick={() => changeLanguage('es')}><i class="fi fi-rs-globe" style={{marginRight:'4px'}}></i> {currentLanguage.toUpperCase()}    <i class="fi fi-br-angle-small-down" ></i>    </label> 
                                {isSubmenu === 3 &&(
                                    <>                                    
                                    <ul className='submenu-item idioma'>                                
                                        <li onClick={() => changeLanguage('es')}>ES </li>     
                                        <li onClick={() => changeLanguage('en')}>EN </li>
                                        <li></li>
                                        <li onClick={() => changeLanguage('fr')}>FR </li>                      
                                    </ul>                                
                                </>
                                )}
                               
                            </li>
                           
                            <li className='btn-primary'  onClick={toggleLateralMenu}>                                
                                {
                                    lateralMenu ? (
                                        <i class="fi fi-rs-cross"></i>
                                    ):(
                                        <i class="fi fi-rs-burger-menu"></i>
                                    )
                                }
                              
                            </li>
                      
                            
                            {/*<li className="navbar-item ">                    
                                <label style={{display:'flex'}} onClick={() => changeLanguage('es')}><i class="fi fi-rr-globe"></i> {currentLanguage.toUpperCase()}    <i class="fi fi-rr-caret-down"></i>    </label>
                                <ul className='submenu-item idioma'>                                
                                    <li onClick={() => changeLanguage('es')}>ES </li>     
                                    <li onClick={() => changeLanguage('en')}>EN </li>
                                    <li onClick={() => changeLanguage('fr')}>FR </li>       
                                                 
                                </ul> 
                            </li> */}
                            
                           
                            <li>
                                <button className='btn-secondary-carga' onClick={toggleMenuExpanded} aria-label="menu lateral">
                                    <i class="fi fi-rs-apps"></i>
                                </button>                                
                            </li>
                           
                        </ul>
                    </div>

                </div>
           </div>
        </div>
    </header>

    {/* Menu lateral DESKTOP*/}
    <aside className={`sidebar ${isActive ? "show" : null}`}>
        <div className='boxSidebar'>
            <div className='boxAsidebar'>
                <div className='btnCerrar'> 
                    <button onClick={toggleMenuExpanded}  className="navbar-toggle " id="toggleButton">                            
                        {/*<i className="fi fi-rr-cross-circle"></i>*/}
                        <i class="fi fi-br-cross"></i>
                    </button>
                </div>
                <div className='blockAsidebar_first'>
                    <ul>                                       
                        <li className='block'><Link to="/nosotros">{t('lateral_menu1')} </Link>
                            <ul>
                                <li><Link to="/nosotros" onClick={toggleMenuExpanded}>{t('lateral_menu2')} </Link></li>
                                {/*<li><Link to="/puertos">Puertos </Link></li>*/}
                                <li><Link to="/flota" onClick={toggleMenuExpanded}>{t('lateral_menu3')} </Link></li>                                              
                                <li><Link to="/certificaciones" onClick={toggleMenuExpanded}>{t('lateral_menu4')} </Link></li>                                       
                                {/*<li><Link to="/itinerarioprueba" onClick={toggleMenuExpanded}>Viaje en curso </Link></li> */}
                            </ul>
                        </li>  
                        <li className='block'><Link to="/soluciones-logisticas">{t('lateral_menu5')}</Link>
                            <ul>
                                <li><Link to="/soluciones-logisticas" onClick={toggleMenuExpanded}>{t('lateral_menu6')}</Link></li>
                               {/*} <li><Link to="/maritimo" onClick={toggleMenuExpanded}>Marítimo </Link></li>
                                <li><Link to="/terrestre" onClick={toggleMenuExpanded}>Terrestre </Link></li>
                                <li><Link to="/multimodal" onClick={toggleMenuExpanded}>Multimodal </Link></li>
                                <li><Link to="/integración-logística" onClick={toggleMenuExpanded}>Integración Logística </Link></li>*/}
                            </ul>
                        </li>  
                        {/* 
                        <li className='block'><a href="?">Soluciones digitales</a>
                            <ul>
                                <li><a href='?'>Marketplace</a></li>
                                <li><a href='?'>Rastreo</a></li>                                                    
                            </ul>
                        </li> 
                        */}
                        <li className='block'><a href="https://booking.bajaferries.com.mx/es/cuenta/" target="_blank" rel="noopener noreferrer">{t('lateral_menu7')}</a>
                            <ul>
                                <li><Link to="/noticias" onClick={toggleMenuExpanded}>{t('lateral_menu8')}</Link></li>
                            </ul>
                        </li>
                        <li className='block'><a href="?">{t('lateral_menu9')}</a>
                            <ul>
                                <li> <a href="https://booking.bajaferries.com.mx/es/cuenta/" target="_blank" rel="noopener noreferrer">{t('lateral_menu10')}</a></li>                                
                            </ul>
                        </li>
                        {/*
                   
                        <li className='block'><a href="?">Prensa</a>
                            <ul>
                                <li><Link to="/kit-de-comunicacion" onClick={toggleMenuExpanded}>Contacto de agencia</Link></li>
                            </ul>
                        </li>*/}
                    </ul>
                </div>
                <div className='blockAsidebar_second'>
                    <ul>
                        {/*
                    <li className='block'><a href="?">RSE</a>
                        <ul>
                            <li><a href='?'>Modelo de sustentabilidad</a></li>
                            <li><a href='?'>Programas</a></li>
                            <li><a href='?'>Voluntariado</a></li>
                        </ul>
                    </li>  
                    */}
                    <li className='block'><a href='?'>{t('lateral_menu20')} </a>                                           
                        <ul>
                            <li><Link to="/contacto" onClick={toggleMenuExpanded}>{t('lateral_menu11')} </Link></li>  
                            <li><Link to="/preguntas-frecuentes" onClick={toggleMenuExpanded}>{t('lateral_menu12')} </Link></li>                              
                            <li><a href="http://proveedores.bajaferries.com/ProveedoresLogin.aspx" target="_blank" rel="noopener noreferrer">{t('lateral_menu13')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a></li>
                        </ul>                                     
                    </li>
                    <li className='block'><a href="?">{t('lateral_menu14')} </a>                      
                        <ul>                            
                            <li><a href="https://eticabajaferries.lineaetica.com.mx/" target="_blank" rel="noopener noreferrer">{t('lateral_menu15')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>   </li>
                            <li><a href="https://eticabajaferries.lineaetica.com.mx/" target="_blank" rel="noopener noreferrer">{t('lateral_menu16')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>   </li>                                                                                                               
                                                                                                              
                        </ul>
                    </li>
                    
                    {/*<li className='block'><Link to="/login-gobernanza" onClick={toggleMenuExpanded}>Gobernanza </Link>
                        <ul>
                            <li>
                                <Link to="/login-gobernanza" onClick={toggleMenuExpanded}>Login</Link>
                            </li>                                                                                    
                        </ul>
                    </li>*/}
                    <li className='block'><Link to="/login-gobernanza" onClick={toggleMenuExpanded}>{t('lateral_menu17')} </Link>
                        <ul>
                            <li>
                                <a href="https://facturacion.bajaferries.com/" target="_blank" rel="noopener noreferrer">{t('lateral_menu18')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>    
                            </li>  
                            <li>
                                <a href="http://proveedores.bajaferries.com/ProveedoresLogin.aspx" target="_blank" rel="noopener noreferrer">{t('lateral_menu19')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>    
                            </li>                                                                                    
                        </ul>
                    </li>
                        
                    </ul>                                        
                    
                </div>
        
                <div className='asidebar_icons_socials'>    
                    <a href="https://www.facebook.com/bajaferriesoficial/" target="_blank" rel="noopener noreferrer"><img src={facebook_icon}  alt='facebook baja ferries'/></a> 
                    <a href="https://www.instagram.com/bajaferriesoficial/" target="_blank" rel="noopener noreferrer"><img src={instagram_icon}  alt='instagram baja ferries'/></a> 
                    <a href="https://open.spotify.com/user/in0rh2go0af0k6asr46bzxun7" target="_blank" rel="noopener noreferrer"><img src={spotify_icon}  alt='spotify baja ferries'/></a> 
                    <a href="https://x.com/bajaferries" target="_blank" rel="noopener noreferrer"><img src={twitter_icon}  alt='twitter baja ferries'/></a> 
                    <a href="https://wa.me/5218003377437?text=Me%20interesa%20una%20cotizaci%C3%B3n" target="_blank" rel="noopener noreferrer"><img src={whatsapp_icon}  alt='whatsapp baja ferries'/></a> 
                    <a href="https://www.youtube.com/@bajaferries2914" target="_blank" rel="noopener noreferrer"><img src={youtube_icon}  alt='youtube baja ferries'/></a>                                                                                
                </div>
            
            </div>
                        
        </div>                                                    
    </aside>

    {/* Menu lateral CELULAR*/}
    <aside className={`lateral ${lateralMenu ? "show" : null}`}>
        <div className='lateral-content carga'>
            <div className='container'>
                <div className='box-sidebar carga'>
                    <div className='block-sidebar carga'>
                        <ul>     
                            <li><Link to="/"><div><i class="fi fi-ss-undo"></i>{t('opc14')}</div></Link></li> 
                            <li><Link to="/rutas_horario"><div><img src={rutasyhorarios} alt=''/>{t('opc12')} </div></Link></li>
                            <li><Link to="/tarifas"><div><img src={tarifas} alt=''/>{t('opc13')}</div></Link></li>                                                                                             
                            <li><Link to="/itinerario"><div><img src={itinerario} alt=''/>{t('title8')}</div>  </Link></li>
                            
                            
                            <li><Link to="/maritimo"><div><img src={itinerario} alt=''/>{t('title1')}</div>  </Link></li>                            
                            <li><Link to="/terrestre"><div><img src={itinerario} alt=''/>{t('title2')}</div>  </Link></li>
                            <li><Link to="/integracion-logistica"><div><img src={itinerario} alt=''/>{t('title3')}</div>  </Link></li>
                        </ul>
                    </div>
                    <div className='block-sidebar carga'>
                        <ul>
                            <li><Link onClick={() => toggleDropdown(3)}>{t('lateral_menu1')} <i class="fi fi-br-angle-small-down"></i></Link>
                            {dropdown === 3 &&(
                                <div>
                                    <ul>
                                        <li><Link to="/nosotros">{t('lateral_menu2')} </Link></li>                                     
                                        <li><Link to="/flota">{t('lateral_menu3')}  </Link></li>
                                        <li><Link to="/certificaciones">{t('lateral_menu4')}  </Link></li>                                                                                 
                                    </ul>
                                </div>
                            )}
                            </li>  

                            <li><Link  onClick={() => toggleDropdown(5)}>{t('lateral_menu20')} <i class="fi fi-br-angle-small-down"></i></Link> 
                            {dropdown === 5 &&(
                                <div>
                                    <ul>
                                        <li><Link to="/contacto">{t('lateral_menu11')} </Link></li>
                                        <li><Link to="/preguntas-frecuentes">{t('lateral_menu12')}  </Link></li>                                        
                                        <li><a href="http://proveedores.bajaferries.com/ProveedoresLogin.aspx" target="_blank" rel="noopener noreferrer">{t('lateral_menu13')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a></li>                                                                                                                                                            
                                    </ul>
                                </div>
                            )}</li>     
                            <li><Link onClick={() => toggleDropdown(6)}>{t('lateral_menu17')} <i class="fi fi-br-angle-small-down"></i></Link> 
                            {dropdown === 6 &&(
                                <div>
                                    <ul>             
                                        <li><a href="https://facturacion.bajaferries.com/" target="_blank" rel="noopener noreferrer">{t('lateral_menu18')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>  </li>
                                        <li><a href="http://proveedores.bajaferries.com/ProveedoresLogin.aspx" target="_blank" rel="noopener noreferrer">{t('lateral_menu19')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a> </li> 
                                        <li><a href="https://eticabajaferries.lineaetica.com.mx/" target="_blank" rel="noopener noreferrer">{t('lateral_menu15')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>   </li>
                                        <li><a href="https://eticabajaferries.lineaetica.com.mx/" target="_blank" rel="noopener noreferrer">{t('lateral_menu16')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>   </li>                                                                                                                                                                                                                    
                                        
                                    </ul>
                                </div>
                            )}
                            </li> 

                            <li><Link to="/noticias">{t('lateral_menu8')}  </Link> </li>
                            <li><a href="https://booking.bajaferries.com.mx/es/cuenta/">{t('lateral_menu9')}</a></li>                                                                                      
                        </ul>
                    </div>
                    <div className='btn-idioma-option carga'>
                        <button onClick={() => changeLanguage('es')} className={currentLanguage === 'es' ? 'active-language' : ''}>Es</button>
                        <button onClick={() => changeLanguage('en')} className={currentLanguage === 'en' ? 'active-language' : ''}>En</button>
                        <button onClick={() => changeLanguage('fr')} className={currentLanguage === 'fr' ? 'active-language' : ''}>Fr</button>
                    </div> 
               
                    <div className='sidebar_icons_socials'>    
                        <a href="https://www.facebook.com/bajaferriesoficial/" target="_blank" rel="noopener noreferrer"><img src={facebook_icon_blue}  alt='facebook baja ferries'/></a> 
                        <a href="https://www.instagram.com/bajaferriesoficial/" target="_blank" rel="noopener noreferrer"><img src={instagram_icon_blue}  alt='instagram baja ferries'/></a> 
                        <a href="https://open.spotify.com/user/in0rh2go0af0k6asr46bzxun7" target="_blank" rel="noopener noreferrer"><img src={spotify_icon_blue}  alt='spotify baja ferries'/></a> 
                        <a href="https://x.com/bajaferries" target="_blank" rel="noopener noreferrer"><img src={twitter_icon_blue}  alt='twitter baja ferries'/></a> 
                        <a href="https://wa.me/5218003377437?text=Me%20interesa%20una%20cotizaci%C3%B3n" target="_blank" rel="noopener noreferrer"><img src={whatsapp_icon_blue}  alt='whatsapp baja ferries'/></a> 
                        <a href="https://www.youtube.com/@bajaferries2914" target="_blank" rel="noopener noreferrer"><img src={youtube_icon_blue}  alt='youtube baja ferries'/></a>                                                                                       
                    </div>
                </div>
            </div>   
        </div>                                                 
    </aside>

    {/* Overlay */}
    <div className={`overlay ${isSubmenu || isActive || lateralMenu ? 'overlay-active' : ''}`}  onClick={closeSubmenu}></div>

    <Outlet />
    
    </>
  )
}
